import React, { ReactElement } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n';

type Props = {
    title?: string
    titleSmall?: string
    description?: string
    widgetWidth?: number
    isCustomLabel?: boolean
}

const EmptyData = ({ title, titleSmall, description, widgetWidth, isCustomLabel }: Props): ReactElement => {
    const isSmall = widgetWidth < window.innerWidth * 0.7
    return (
        <NoDataContainer isSmall={isSmall}>
            <Icon isSmall={isSmall}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30.5 8C31.3125 8 32 8.6875 32 9.5V14.5C32 15.375 31.3125 16 30.5 16H30V26.4375C30 27.25 29.375 28 28.375 28H28V30C28 31.125 27.0625 32 26 32H24C22.875 32 22 31.125 22 30V28H10V30C10 31.125 9.0625 32 8 32H6C4.875 32 4 31.125 4 30V28C2.875 28 2 27.125 2 26V16H1.5C0.625 16 0 15.375 0 14.5V9.5C0 8.6875 0.625 8 1.5 8H2V5C2 2.25 8.1875 0 16 0C23.75 0 30 2.25 30 5V8H30.5ZM7 25C8.0625 25 9 24.125 9 23C9 21.9375 8.0625 21 7 21C5.875 21 5 21.9375 5 23C5 24.125 5.875 25 7 25ZM8 18H24C25.0625 18 26 17.125 26 16V8C26 6.9375 25.0625 6 24 6H8C6.875 6 6 6.9375 6 8V16C6 17.125 6.875 18 8 18ZM25 25C26.0625 25 27 24.125 27 23C27 21.9375 26.0625 21 25 21C23.875 21 23 21.9375 23 23C23 24.125 23.875 25 25 25Z" fill="#008AC7" />
                </svg>
            </Icon>
            <div className={isSmall ? 'small-desc' : ''}>
                <b>{isSmall ? (isCustomLabel ? titleSmall || title : i18n('Please select a vehicle')) : (isCustomLabel ? title : i18n('Select a vehicle'))}</b>
                <label>{isCustomLabel ? description : i18n('to load information in this section.')}</label>
            </div>
        </NoDataContainer>
    )
}

const Icon = styled.span`
    padding-top: ${({ isSmall }) => isSmall ? '15px' : '0'};
`
const NoDataContainer = styled.div<{ isSmall: boolean }>`
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: ${({ isSmall }) => isSmall ? 'row' : 'column'};
    justify-content: center;
    align-items: center;
    position: static;
    left: 0%;
    right: 0%;
    top: 50%;
    b, label {
        font-size: ${({ isSmall }) => isSmall ? '14px' : '16px'};
    }
    b {
        margin-top: 10px;
    }
    label {
        color: #797979;
        margin-top: 0px;
        font-family: ${({ theme }) => theme['font-regular']};
    }
    .small-desc {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        padding-left: 16px;
    }

`

export default EmptyData
